import React from "react";
import './style.scss'

export const Button = ({
    theme, onClick, direction, type, children, disabled
}) =>
{
    const clickHandler = (event) => {
        if (direction !== undefined) {
            localStorage.setItem('duration', direction);
        }

        onClick(event);
    }

    const classes = ['btn'];

    if (theme !== undefined) {
        classes.push.apply(classes,
            theme.split(' ').map(modifier => `btn-theme-${modifier}`)
        );
    }

    return (
        <button
            className={classes.join(' ')}
            onClick={clickHandler}
            type={type}
            disabled={disabled}
        >
            <div className={'btn__background'}/>
            {children}
        </button>
    )
}